<template>
  <div>
    <vs-popup
      :active.sync="infoModal.active"
      title="รายละเอียด"
      class="custom-popup"
    >
      <div class="mb-5">
        <p v-html="infoModal.text"></p>
      </div>
    </vs-popup>
    <vx-card title="แก้ไขผลการดำเนินคดี">
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <div class="vx-row">
                <div class="vx-col w-1/3">
                  <validation-provider :name="$t('sections.prosecution.dataForm.statusDate')" rules="required" v-slot="{ errors }">
                    <label class="vs-input--label">{{$t('sections.prosecution.dataForm.statusDate')}}*</label>
                    <flat-pickr :config="configDatePicker" class="w-full" v-model="form.date"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.prosecution.dataForm.caseStatus')" rules="required" v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.caseStatus") }}* <a class="cursor-pointer" @click="onPressedActiveInfoModal('caseStatus')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                    <v-select v-model="form.caseStatus" :clearable="false" :options="_caseStatusOptions" :reduce="res => res.value" />
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <validation-provider :name="$t('sections.prosecution.dataForm.remark')" rules="" v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.remark') }}</label>
                    <vs-textarea class="w-full mt-2 mb-2" v-model="form.remark" rows="5"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.fileName') }} <small>(สามารถแนบไฟล์ได้ไม่จำกัด .jpg .jpeg .png .pdf .xlsx .xls .csv .doc .docx)</small></label>
                  <vs-input type="text" class="w-full mb-2" v-model="form.description" />
                  <input type="file" @change="onFileChange" ref="inputFile" accept=".jpg, .jpeg, .png, .pdf, .xlsx, .xls, .csv, .doc, .docx" />
                  <vs-button class="btn-icon float-right mr-3" size="small" color="success" :disabled="!selectedFile || !form.description" @click="onUploadFile">เพิ่ม</vs-button>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col w-full">
                  <vs-divider position="left" class="mb-0"></vs-divider>
                  <vs-list>
                    <vs-list-item v-for="file in form.files" :key="file.id" :title="file.description" >
                      <vs-button type="line" line-origin="left" color="success" size="small" @click="download(file)" :disabled="!file.fileName">เรียกดู</vs-button>
                      <vs-button class="btn-icon" size="small" color="danger" @click="del(file.id)">ลบ</vs-button>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.prosecution.dataForm.action.btnEdit") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.prosecution.dataForm.action.btnCancel") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {ValidationProvider} from 'vee-validate'
import {createNamespacedHelpers, mapGetters} from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import {Thai} from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import {getUploadsUrl} from "@/utils/upload";
import {IFileFrom, IProsecutionType} from "@/constants/interface";
import DividerDefault from "@/views/components/vuesax/divider/DividerDefault.vue";

const {mapActions: mapProsecutionActions, mapState: mapProsecutionState} = createNamespacedHelpers('Prosecution')

export default {
  name: "ProsecutionTransactionAdd",
  components: {
    DividerDefault,
    vSelect,
    ValidationProvider,
    flatPickr,
  },
  data() {
    return {
      infoModal: {
        active: false,
        text: ""
      },
      form: {
        prosecution: {id: this.$route.params.prosecutionId || ''},
        id: '',
        seq: 0,
        date: new Date(),
        caseStatus: null,
        remark: '',
        files: []
      },
      configDatePicker: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y"
      },
      selectedFile: null,
      reportServer: process.env.VUE_APP_REPORT_SERVER
    }
  },
  async created() {
    const vm = this;
    const { getProsecutionDetail } = vm;
    await getProsecutionDetail({form: {id: vm.$route.params.prosecutionDetailId}})
    await vm.reset();
  },
  computed: {
    ...mapProsecutionState(['status', 'prosecutionDetail', 'files']),
    ...mapGetters({
      caseStatusProsecuteCaseOptions: 'Prosecution/caseStatusProsecuteCaseOptions',
      caseStatusEnforceCaseOptions: 'Prosecution/caseStatusEnforceCaseOptions',
    }),
    caseStatusOptions(){
      if(this.$route.params.prosecutionType === IProsecutionType.prosecuteCase){
        return this.caseStatusProsecuteCaseOptions
      }else if(this.$route.params.prosecutionType === IProsecutionType.enforceCase){
        return this.caseStatusEnforceCaseOptions
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapProsecutionActions(['getProsecutionDetail', 'updateProsecutionDetail', 'uploadFile', 'updateFile', 'createFile', 'deleteFile']),
    async submit() {
      const vm = this
      const {updateProsecutionDetail} = vm
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        await updateProsecutionDetail({
          id: vm.form.id,
          form: {
            date: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.date),
            caseStatus: vm.form.caseStatus,
            remark: vm.form.remark,
          },
          vm
        })
        this.$router.go(-1);
      })
    },
    reset() {
      const vm = this;
      const { prosecutionDetail } = vm;
      vm.form = {
        id: prosecutionDetail.id,
        seq: prosecutionDetail.seq,
        date: vm.$options.filters.convYYYYMMDDToDDMMYYYY(prosecutionDetail.date),
        caseStatus: prosecutionDetail.caseStatus,
        files: prosecutionDetail.files.map(file => {
          return {
            id: file.id,
            description: file.description,
            fileName: file.fileName,
            fileType: file.fileType,
            pathUrl: file.pathUrl
          }
        }),
        remark: prosecutionDetail.remark,
      }
      vm.form.description = ""
      vm.selectedFile = null
      vm.$refs.inputFile.value = null
    },
    download(file) {
      const url = getUploadsUrl(file.fileName)
      window.open(url, '_blank');
    },
    openUrl(url) {
      window.open(url, '_blank');
    },
    async del(id) {
      const vm = this
      const {deleteFile} = vm
      vm.actionID = id
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: async () => {
          await deleteFile({
            form: {
              id
            },
            vm
          });
          const index = vm.form.files.findIndex(file => file.id === id)
          vm.form.files.splice(index, 1)
        }
      })
    },
    onFileChange(e) {
      this.selectedFile = e.target.files[0]; // accessing file;
    },
    async onUploadFile() {
      const vm = this
      const formData = new FormData();
      const {createFile} = vm;
      formData.append("file", vm.selectedFile);  // appending file
      const result = await vm.uploadFile({
        id: vm.$route.params.contractId,
        form: {
          formData: formData
        },
        vm
      });
      const file = await createFile({
        form: {
          contract: {id: vm.$route.params.contractId || ''},
          prosecution: {id: vm.$route.params.prosecutionId || ''},
          prosecutionDetail: {id: vm.$route.params.prosecutionDetailId || ''},
          fileFrom: IFileFrom.prosecution,
          description: vm.form.description,
          fileName: result.fileName,
          fileType: result.fileType,
          pathUrl: result.pathUrl
        },
        vm
      });
      vm.form.files.push({
        id: file.id,
        description: file.description,
        fileName: file.fileName,
        fileType: file.fileType,
        pathUrl: file.pathUrl
      })
      vm.form.description = ""
      vm.selectedFile = null
      vm.$refs.inputFile.value = null
    },
    async onPressedActiveInfoModal(type) {
      if(type === 'caseStatus'){
        this.infoModal.text = 'กรณีสัญญาที่ผ่านการปรับโครสร้างหนี้มาแล้ว จะสามารถบันทึกได้ตั้งแต่ <b>"ส่งเรื่องบังคับคดี"</b> เป็นต้นไปเท่านั้น'
      }
      this.infoModal.active = true
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.vx-col {
  margin-bottom: 1rem; /* This is the equivalent of Bootstrap's mt-5 */
}
</style>
